import { Grid2, Stack } from '@mui/material'
import { memo } from 'react'

import FilterMenu from '../shared/filterMenu/FilterMenu'

import { SOCIAL_MEDIA } from 'src/constants/app'
import MoreInformationWrapper from 'wrappers/MoreInformationWrapper'
import { ACCOUNT_CHANGE_ACTION } from '../../constants/auth'
import ManageAccountsContainer from '../../containers/ManageAccountsContainer'
import { SETTING_FILTER_TYPE } from '../../util/settings.helpers'
import PageTitle from '../shared/pageTitle/PageTitle'
import AccountNumber from './AccountNumber'
import ChangeCountry from './ChangeCountry'
import ChangeEmailAddress from './ChangeEmailAddress'
import ChangePassword from './ChangePassword'
import ChangePersonalInfo from './ChangePersonalInfo'
import DisplayEmailAddress from './DisplayEmailAddress'
import KYCInfo from './KYCInfo'
import LoadingSkeleton from './LoadingSkeleton'

const UserAccount = ({
  accountProfile,
  dispatchAction,
  updatePersonalInfo,
  changeEmailAddress,
  changePassword,
  changeCountry,
  signedUpVia,
  t,
  tabOptions,
  filterBy,
  onChangeFilterMenu,
  authAction,
  kycProfile,
  onContinueKYC,
  onRefreshKYC,
  isKycSuccess
}) => {
  const pageTitle = t('navigation.settings')
  const renderTabData = () => {
    if (accountProfile.loading) {
      return <LoadingSkeleton />
    }
    switch (filterBy) {
      case SETTING_FILTER_TYPE.GENERAL:
        return (
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <AccountNumber accountProfile={accountProfile} t={t} />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Stack spacing={3}>
                <ChangePersonalInfo
                  accountProfile={accountProfile}
                  dispatchAction={dispatchAction}
                  onFormSubmit={updatePersonalInfo}
                  t={t}
                  isPresent={authAction === ACCOUNT_CHANGE_ACTION.PERSONAL_INFO}
                  isKycSuccess={isKycSuccess}
                />
                <ChangeCountry
                  accountProfile={accountProfile}
                  dispatchAction={dispatchAction}
                  onFormSubmit={changeCountry}
                  t={t}
                  isPresent={authAction === ACCOUNT_CHANGE_ACTION.COUNTRY}
                  isKycSuccess={isKycSuccess}
                />
              </Stack>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <KYCInfo
                t={t}
                kycProfile={kycProfile}
                onContinueKYC={onContinueKYC}
                onRefreshKYC={onRefreshKYC}
              />
            </Grid2>
          </Grid2>
        )

      case SETTING_FILTER_TYPE.CONNECTED_ACCOUNTS:
        return <ManageAccountsContainer />

      case SETTING_FILTER_TYPE.SECURITY:
        return (
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12, md: 6 }}>
              {signedUpVia === SOCIAL_MEDIA.GOOGLE ? (
                <DisplayEmailAddress
                  email={accountProfile.email}
                  signedUpVia={signedUpVia}
                  t={t}
                />
              ) : (
                <ChangeEmailAddress
                  accountProfile={accountProfile}
                  dispatchAction={dispatchAction}
                  onFormSubmit={changeEmailAddress}
                  t={t}
                  isPresent={authAction === ACCOUNT_CHANGE_ACTION.EMAIL}
                />
              )}
            </Grid2>
            {!signedUpVia && (
              <Grid2 size={{ xs: 12, md: 6 }}>
                <ChangePassword
                  accountProfile={accountProfile}
                  dispatchAction={dispatchAction}
                  onFormSubmit={changePassword}
                  t={t}
                  isPresent={authAction === ACCOUNT_CHANGE_ACTION.PASSWORD}
                />
              </Grid2>
            )}
            <Grid2 size={{ xs: 12, md: 6 }}>
              <MoreInformationWrapper t={t} />
            </Grid2>
          </Grid2>
        )

      default:
        return null
    }
  }
  return (
    <>
      <PageTitle title={pageTitle} />
      <FilterMenu
        value={filterBy}
        options={tabOptions}
        onChange={onChangeFilterMenu}
      />
      {renderTabData()}
    </>
  )
}

export default memo(UserAccount)
